// ** Icons Import
import { FileText, Circle, Square, UserCheck, Clock, Watch, Sliders, Settings, Users, Calendar, MessageCircle } from 'react-feather'
import user from '@src/assets/images/NavigationIcons/user.png'
import ThemeAwareIcon from './ThemeAwareIcon'
export default [
  {
    id: 'pages',
    title: 'My Profile',
    icon: <ThemeAwareIcon src={user} alt='My Profile' className='me-75' />,
    permissions: ['admin', 'any', 'limited'],
    children: [
      {
        id: 'accountSettings',
        title: 'Account Settings',
        icon: <Settings size={12} />,
        permissions: ['admin', 'any', 'limited', 'masteradmin'],
        navLink: '/my-profile/account-settings'
      },
      {
        id: 'dailyPlanning',
        title: 'Daily Planning',
        icon: <Watch size={12} />,
        permissions: ['admin', 'any', 'masteradmin'],
        navLink: '/my-profile/daily-planning'
      },
      {
        id: 'myTimeSheet',
        title: 'Time Sheet',
        icon: <Clock size={12} />,
        permissions: ['admin', 'any', 'masteradmin'],
        navLink: '/my-profile/my-time-sheet'
      },
      {
        id: 'resourcePlanning',
        title: 'Resource Planning',
        icon: <Users size={12} />,
        permissions: ['admin', 'any', 'masteradmin'],
        navLink: '/my-profile/resource-planning'
      },
      {
        id: 'booktimeoff',
        title: 'Book Time Off',
        icon: <Calendar size={12} />,
        permissions: ['admin', 'any', 'masteradmin'],
        navLink: '/my-profile/book-time-off'
      },
      {
        id: 'zendeskTickets',
        title: 'Zendesk Tickets',
        icon: <MessageCircle size={12} />,
        permissions: ['admin', 'any', 'limited', 'masteradmin'],
        navLink: '/my-profile/zendesk-tickets'
      }
    ]
  },
  {
    id: 'wiki',
    title: 'Wiki',
    icon: <Circle size={12} />,
    permissions: ['admin1', 'any1', 'masteradmin1'],
    children: [
      {
        id: 'wikiList',
        title: 'List',
        permissions: ['admin', 'any', 'masteradmin'],
        navLink: '/pages/wiki/list'
      },
      {
        id: 'wikiDetail',
        title: 'Detail',
        permissions: ['admin', 'any', 'masteradmin'],
        navLink: '/pages/wiki/detail'
      },
      {
        id: 'wikiEdit',
        title: 'Edit',
        permissions: ['admin', 'any', 'masteradmin'],
        navLink: '/pages/wiki/edit'
      }
    ]
  }
]
